// 各 Action には引数を記述すること
module.exports = {
    // Tag
    CREATE_TAG: 'CREATE_TAG',
    UPDATE_TAG: 'UPDATE_TAG',
    DELETE_TAG: 'DELETE_TAG',
    TOGGLE_TAG: 'TOGGLE_TAG',

    // Tag Category
    CATEGORIZE_TAG: 'CATEGORIZE_TAG',
    CREATE_TAG_CATEGORY: 'CREATE_TAG_CATEGORY',
    UPDATE_TAG_CATEGORY: 'UPDATE_TAG_CATEGORY',
    DELETE_TAG_CATEGORY: 'DELETE_TAG_CATEGORY',
    TOGGLE_TAG_CATEGORY: 'TOGGLE_TAG_CATEGORY',

    // Task
    CREATE_TASK: 'CREATE_TASK',
    UPDATE_TASK: 'UPDATE_TASK',
    DELETE_TASK: 'DELETE_TASK',

    CREATE_TASK_TYPE: 'CREATE_TASK_TYPE',

    // Member
    CREATE_MEMBER: 'CREATE_MEMBER',
    TOGGLE_MEMBER: 'TOGGLE_MEMBER',

    // Comment
    CREATE_COMMENT: 'CREATE_COMMENT',

    // Commit
    CREATE_COMMIT: 'CREATE_COMMIT',

    // Node
    CREATE_NODE: 'CREATE_NODE',
    UPDATE_NODE: 'UPDATE_NODE',
    DELETE_NODE: 'DELETE_NODE',
    MERGE_NODE: 'MERGE_NODE',
    UPDATE_NODE_SYNC_STATE: 'UPDATE_NODE_SYNC_STATE',
    UPDATE_NODE_EDIT_STATE: 'UPDATE_NODE_EDIT_STATE',
    ADD_TAG_TO_NODE: 'ADD_TAG_TO_NODE',
    REMOVE_TAG_FROM_NODE: 'REMOVE_TAG_FROM_NODE',
    ADD_OWNER_TO_NODE: 'ADD_OWNER_TO_NODE',
    REMOVE_OWNER_FROM_NODE: 'REMOVE_OWNER_FROM_NODE',
    CREATE_RECORD_TYPE: 'CREATE_RECORD_TYPE',

    // Link
    CREATE_LINK: 'CREATE_LINK',
    UPDATE_LINK: 'UPDATE_LINK',
    DELETE_LINK: 'DELETE_LINK',
    MERGE_LINK: 'MERGE_LINK',
    UPDATE_LINK_SYNC_STATE: 'UPDATE_LINK_SYNC_STATE',
    UPDATE_LINK_EDIT_STATE: 'UPDATE_LINK_EDIT_STATE',
    CREATE_RELATION_TYPE: 'CREATE_RELATION_TYPE',

    // Diagram
    CREATE_DIAGRAM: 'CREATE_DIAGRAM',
    UPDATE_DIAGRAM: 'UPDATE_DIAGRAM',
    DELETE_DIAGRAM: 'DELETE_DIAGRAM',

    // Diagram Directory
    CREATE_DIAGRAM_DIRECTORY: 'CREATE_DIAGRAM_DIRECTORY',
    UPDATE_DIAGRAM_DIRECTORY: 'UPDATE_DIAGRAM_DIRECTORY',
    DELETE_DIAGRAM_DIRECTORY: 'DELETE_DIAGRAM_DIRECTORY',

    // Node Meta Info
    CREATE_NODE_META: 'CREATE_NODE_META',
    UPDATE_NODE_META: 'UPDATE_NODE_META',
    DELETE_NODE_META: 'DELETE_NODE_META',
    MERGE_NODE_META: 'MERGE_NODE_META',
    UPDATE_NODE_META_SYNC_STATE: 'UPDATE_NODE_META_SYNC_STATE',
    UPDATE_NODE_META_EDIT_STATE: 'UPDATE_NODE_META_EDIT_STATE',

    // Link Meta Info
    CREATE_LINK_META: 'CREATE_LINK_META',
    UPDATE_LINK_META: 'UPDATE_LINK_META',
    DELETE_LINK_META: 'DELETE_LINK_META',
    MERGE_LINK_META: 'MERGE_LINK_META',
    UPDATE_LINK_META_SYNC_STATE: 'UPDATE_LINK_META_SYNC_STATE',
    UPDATE_LINK_META_EDIT_STATE: 'UPDATE_LINK_META_EDIT_STATE',

    // Group
    CREATE_GROUP: 'CREATE_GROUP',
    UPDATE_GROUP: 'UPDATE_GROUP',
    DELETE_GROUP: 'DELETE_GROUP',

    // Timeline
    CREATE_TIMELINE: 'CREATE_TIMELINE',
    READ_TIMELINE: 'READ_TIMELINE',

    // Review
    CREATE_REVIEW: 'CREATE_REVIEW',
    READ_REVIEW: 'READ_REVIEW',

    // User Request
    CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
    ADD_COMMENT_TO_USER_REQUEST: 'ADD_COMMENT_TO_USER_REQUEST',

    // Recent Change
    CREATE_RECENT_CHANGE: 'CREATE_RECENT_CHANGE',

    // Search Result
    CREATE_SEARCH_RESULT: 'CREATE_SEARCH_RESULT',

    // Event
    CREATE_EVENT: 'CREATE_EVENT',

    // Milestone
    CREATE_MILESTONE: 'CREATE_MILESTONE',
    UPDATE_MILESTONE: 'UPDATE_MILESTONE',
    DELETE_MILESTONE: 'DELETE_MILESTONE'
};



// WEBPACK FOOTER //
// ./common/domain/action/index.js